<template>
    <div class="inner">
        <div class="top">
            <div class="part left">
                <p class="title">
                    各领域引文影响力
                </p>
                <div class="chart" id="chart1">

                </div>
            </div>
            <div class="part map">
                <p class="title">
                    各国发文量
                </p>
                <div class="chart" id="map">

                </div>
            </div>
            <div class="part right">
                <p class="title">
                    各领域活跃指数
                </p>
                <div class="chart" id="chart2">

                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="part">
                <icon-title title="高被引论文数量" iconName="sandengfen"></icon-title>
                <div class="chart" id="chart3">

                </div>
            </div>
            <div class="part">
                <icon-title title="论文引文影响力" iconName="wenben"></icon-title>
                <div class="chart" id="chart4">

                </div>
            </div>
            <div class="part">
                <icon-title title="论文数量占全球论文份额" iconName="geleihuiyuan"></icon-title>
                <div class="chart" id="chart5">

                </div>
            </div>
            <div class="part">
                <icon-title title="论文被引用量占全球份额" iconName="kjtzbxueke"></icon-title>
                <div class="chart" id="chart6">

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import IconTitle from '@/components/icontitle';

    import {
        worldPublishCount,
        topPaperCount,
        paperCountScale,
        paperQuoteScale,
        fieldPaperInfluence,
        fieldPaperActive,
        paperInfluence
    } from '@/assets/scripts/api/xsdt';
    const mapLineColor = '#00CCFF';
    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const lineChartColor2 = ['#FB058F', '#00CCFF'];
    const mapColor = ['#cbfdff', '#8fadff', '#6278ff', '#4858e7', '#3f4cc3', '#232a6f', '#1a2165'];
    const pieColor = [
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        }
    ];

    const GRID = {
        left: '0',
        top: '10%',
        bottom: '10%',
        right: '0',
        containLabel: true
    };


    export default {
        name: 'ZhongWaiXueShu',
        components: {
            IconTitle
        },
        data() {
            return {
                country: '中国,美国',
                countryData: ['中国', '美国'],
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

                worldPublishCount().then(({data}) => {
                    this.initWorldMapChart(data);
                })

                this.initMapChart();
            },
            initMapChart(){
                // 各领域引文影响力
                fieldPaperInfluence(this.country).then(({data}) => {
                    this.initRadarChart1(data);
                })

                // 各领域活跃指数
                fieldPaperActive(this.country).then(({data}) => {
                    this.initRadarChart2(data);
                })

                // 论文高被引数量
                topPaperCount(this.country).then(({data}) => {
                    this.initChart3(data);
                })

                //   论文引文影响力
                paperInfluence(this.country).then(({data}) => {
                    this.initChart4(data);
                })


                // 论文数量占全球份额
                paperCountScale(this.country).then(({data}) => {
                    this.initChart5(data);
                })

                // 论文引用占全球份额
                paperQuoteScale(this.country).then(({data}) => {
                    this.initChart6(data);
                })
            },
            initRadarChart1(data){
                let chart1 = echarts.init(document.getElementById('chart1')),
                    option1 = this.creatRadarOption(data, 0);

                chart1.setOption(option1, true);
                chart1.resize();
                this.$winResize(chart1.resize);
            },
            initRadarChart2(data){
                let chart2 = echarts.init(document.getElementById('chart2')),
                    option2 = this.creatRadarOption(data, 1);

                chart2.setOption(option2, true);
                chart2.resize();
                this.$winResize(chart2.resize);
            },
            initChart3(data) {
                let chart = echarts.init(document.getElementById('chart3')),
                    option = this.creatLineOption(data, 'number');

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart4(data) {
                let chart = echarts.init(document.getElementById('chart4')),
                    option = this.creatLineOption(data);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart5(data) {
                let chart = echarts.init(document.getElementById('chart5')),
                    option = this.creatLineOption(data);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart6(data) {
                let chart = echarts.init(document.getElementById('chart6')),
                    option = this.creatLineOption(data);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initWorldMapChart(data){
                let map = echarts.init(document.getElementById('map')),
                    option = this.getMapOption(data);

                map.setOption(option, true);
                map.resize();
                this.$winResize(map.resize);
                this.changeMapChart(data.selected, map);
            },
            getMapOption(data) {
                let selectData = data.selected;
                let map = data.all;
                let valData = [];

                let mapData = map.map((item) => {
                    item.name == '美国' ? this.mapTotalData = item.value : '';

                    valData.push(item.value)
                    return {
                        value: item.value,
                        name: item.name
                    };
                });

                return {
                    tooltip: {
                        triggerOn: "mousemove",
                        formatter: function (params) {
                            let val = isNaN(params.value)? 0: params.value;

                            if (params.name !== '') {
                                var a = '<span>' + params.name + '</span>';
                                var b = '<span>' + val + '</span>';
                                return [a, b].join(' :  ');
                            }
                        },
                        backgroundColor: 'rgba(29, 38, 71)',
                    },
                    geo: {
                        show: true,
                        map: 'world',
                        zoom: 1.2,
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderWidth: 0,
                                areaColor: '#fff'
                            },
                            emphasis: {
                                areaColor: '#cbfdff'
                            }
                        },
                        nameMap: {
                            Afghanistan: '阿富汗',
                            Singapore: '新加坡',
                            Angola: '安哥拉',
                            Albania: '阿尔巴尼亚',
                            'United Arab Emirates': '阿联酋',
                            Argentina: '阿根廷',
                            Armenia: '亚美尼亚',
                            'French Southern and Antarctic Lands': '法属南半球和南极领地',
                            Australia: '澳大利亚',
                            Austria: '奥地利',
                            Azerbaijan: '阿塞拜疆',
                            Burundi: '布隆迪',
                            Belgium: '比利时',
                            Benin: '贝宁',
                            'Burkina Faso': '布基纳法索',
                            Bangladesh: '孟加拉国',
                            Bulgaria: '保加利亚',
                            'The Bahamas': '巴哈马',
                            'Bosnia and Herzegovina': '波斯尼亚和黑塞哥维那',
                            Belarus: '白俄罗斯',
                            Belize: '伯利兹',
                            Bermuda: '百慕大',
                            Bolivia: '玻利维亚',
                            Brazil: '巴西',
                            Brunei: '文莱',
                            Bhutan: '不丹',
                            Botswana: '博茨瓦纳',
                            'Central African Republic': '中非共和国',
                            Canada: '加拿大',
                            Switzerland: '瑞士',
                            Chile: '智利',
                            China: '中国',
                            'Ivory Coast': '象牙海岸',
                            Cameroon: '喀麦隆',
                            'Democratic Republic of the Congo': '刚果民主共和国',
                            'Republic of the Congo': '刚果共和国',
                            Colombia: '哥伦比亚',
                            'Costa Rica': '哥斯达黎加',
                            Cuba: '古巴',
                            'Northern Cyprus': '北塞浦路斯',
                            Cyprus: '塞浦路斯',
                            'Czech Republic': '捷克共和国',
                            Germany: '德国',
                            Djibouti: '吉布提',
                            Denmark: '丹麦',
                            'Dominican Republic': '多明尼加共和国',
                            Algeria: '阿尔及利亚',
                            Ecuador: '厄瓜多尔',
                            Egypt: '埃及',
                            Eritrea: '厄立特里亚',
                            Spain: '西班牙',
                            Estonia: '爱沙尼亚',
                            Ethiopia: '埃塞俄比亚',
                            Finland: '芬兰',
                            Fiji: '斐',
                            'Falkland Islands': '福克兰群岛',
                            France: '法国',
                            Gabon: '加蓬',
                            'United Kingdom': '英国',
                            Georgia: '格鲁吉亚',
                            Ghana: '加纳',
                            Guinea: '几内亚',
                            Gambia: '冈比亚',
                            'Guinea Bissau': '几内亚比绍',
                            Greece: '希腊',
                            Greenland: '格陵兰',
                            Guatemala: '危地马拉',
                            'French Guiana': '法属圭亚那',
                            Guyana: '圭亚那',
                            Honduras: '洪都拉斯',
                            Croatia: '克罗地亚',
                            Haiti: '海地',
                            Hungary: '匈牙利',
                            Indonesia: '印度尼西亚',
                            India: '印度',
                            Ireland: '爱尔兰',
                            Iran: '伊朗',
                            Iraq: '伊拉克',
                            Iceland: '冰岛',
                            Israel: '以色列',
                            Italy: '意大利',
                            Jamaica: '牙买加',
                            Jordan: '约旦',
                            Japan: '日本',
                            Kazakhstan: '哈萨克斯坦',
                            Kenya: '肯尼亚',
                            Kyrgyzstan: '吉尔吉斯斯坦',
                            Cambodia: '柬埔寨',
                            Kosovo: '科索沃',
                            Kuwait: '科威特',
                            Laos: '老挝',
                            Lebanon: '黎巴嫩',
                            Liberia: '利比里亚',
                            Libya: '利比亚',
                            'Sri Lanka': '斯里兰卡',
                            Lesotho: '莱索托',
                            Lithuania: '立陶宛',
                            Luxembourg: '卢森堡',
                            Latvia: '拉脱维亚',
                            Morocco: '摩洛哥',
                            Moldova: '摩尔多瓦',
                            Madagascar: '马达加斯加',
                            Mexico: '墨西哥',
                            Macedonia: '马其顿',
                            Mali: '马里',
                            Myanmar: '缅甸',
                            Montenegro: '黑山',
                            Mongolia: '蒙古',
                            Mozambique: '莫桑比克',
                            Mauritania: '毛里塔尼亚',
                            Malawi: '马拉维',
                            Malaysia: '马来西亚',
                            Namibia: '纳米比亚',
                            'New Caledonia': '新喀里多尼亚',
                            Niger: '尼日尔',
                            Nigeria: '尼日利亚',
                            Nicaragua: '尼加拉瓜',
                            Netherlands: '荷兰',
                            Norway: '挪威',
                            Nepal: '尼泊尔',
                            'New Zealand': '新西兰',
                            Oman: '阿曼',
                            Pakistan: '巴基斯坦',
                            Panama: '巴拿马',
                            Peru: '秘鲁',
                            Philippines: '菲律宾',
                            'Papua New Guinea': '巴布亚新几内亚',
                            Poland: '波兰',
                            'Puerto Rico': '波多黎各',
                            'North Korea': '北朝鲜',
                            Portugal: '葡萄牙',
                            Paraguay: '巴拉圭',
                            Qatar: '卡塔尔',
                            Romania: '罗马尼亚',
                            Russia: '俄罗斯',
                            Rwanda: '卢旺达',
                            'Western Sahara': '西撒哈拉',
                            'Saudi Arabia': '沙特阿拉伯',
                            Sudan: '苏丹',
                            'South Sudan': '南苏丹',
                            Senegal: '塞内加尔',
                            'Solomon Islands': '所罗门群岛',
                            'Sierra Leone': '塞拉利昂',
                            'El Salvador': '萨尔瓦多',
                            Somaliland: '索马里兰',
                            Somalia: '索马里',
                            'Republic of Serbia': '塞尔维亚',
                            Suriname: '苏里南',
                            Slovakia: '斯洛伐克',
                            Slovenia: '斯洛文尼亚',
                            Sweden: '瑞典',
                            Swaziland: '斯威士兰',
                            Syria: '叙利亚',
                            Chad: '乍得',
                            Togo: '多哥',
                            Thailand: '泰国',
                            Tajikistan: '塔吉克斯坦',
                            Turkmenistan: '土库曼斯坦',
                            'East Timor': '东帝汶',
                            'Trinidad and Tobago': '特里尼达和多巴哥',
                            Tunisia: '突尼斯',
                            Turkey: '土耳其',
                            Uganda: '乌干达',
                            Ukraine: '乌克兰',
                            Uruguay: '乌拉圭',
                            'United States': '美国',
                            Uzbekistan: '乌兹别克斯坦',
                            Venezuela: '委内瑞拉',
                            Vietnam: '越南',
                            Vanuatu: '瓦努阿图',
                            'West Bank': '西岸',
                            Yemen: '也门',
                            'South Africa': '南非',
                            Zambia: '赞比亚',
                            Korea: '韩国',
                            Tanzania: '坦桑尼亚',
                            Zimbabwe: '津巴布韦',
                            Congo: '刚果',
                            'Central African Rep.': '中非',
                            Serbia: '塞尔维亚',
                            'Bosnia and Herz.': '波黑',
                            'Czech Rep.': '捷克',
                            'W. Sahara': '西撒哈拉',
                            'Lao PDR': '老挝',
                            'Dem.Rep.Korea': '朝鲜',
                            'Falkland Is.': '福克兰群岛',
                            'Timor-Leste': '东帝汶',
                            'Solomon Is.': '所罗门群岛',
                            Palestine: '巴勒斯坦',
                            'N. Cyprus': '北塞浦路斯',
                            Aland: '奥兰群岛',
                            'Fr. S. Antarctic Lands': '法属南半球和南极陆地',
                            Mauritius: '毛里求斯',
                            Comoros: '科摩罗',
                            'Eq. Guinea': '赤道几内亚',
                            'Guinea-Bissau': '几内亚比绍',
                            'Dominican Rep.': '多米尼加',
                            'Saint Lucia': '圣卢西亚',
                            Dominica: '多米尼克',
                            'Antigua and Barb.': '安提瓜和巴布达',
                            'U.S. Virgin Is.': '美国原始岛屿',
                            Montserrat: '蒙塞拉特',
                            Grenada: '格林纳达',
                            Barbados: '巴巴多斯',
                            Samoa: '萨摩亚',
                            Bahamas: '巴哈马',
                            'Cayman Is.': '开曼群岛',
                            'Faeroe Is.': '法罗群岛',
                            'IsIe of Man': '马恩岛',
                            Malta: '马耳他共和国',
                            Jersey: '泽西',
                            'Cape Verde': '佛得角共和国',
                            'Turks and Caicos Is.': '特克斯和凯科斯群岛',
                            'St. Vin. and Gren.': '圣文森特和格林纳丁斯'
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: Math.max.apply(null, valData),
                        show: false,
                        inRange: {
                            color: mapColor
                        }
                    },
                    series: [
                        {
                            type: 'map',
                            geoIndex: 0,
                            data: mapData
                        },
                        {
                            name: '散点',
                            type: 'scatter',
                            coordinateSystem: 'geo',
                            data: this.convertData(selectData),
                            symbolSize: 10,
                            label: {
                                color: '#fff',
                                formatter: '{b}',
                                position: 'left',
                                show: true,
                                lineHeight: 20,
                                borderColor: mapLineColor,
                                borderWidth: 1,
                                padding: [0, 11],
                                fontSize: 14,
                                borderRadius: 2,
                                backgroundColor: 'rgba(8,11,38,0.8)'
                            },
                            itemStyle: {
                                borderColor: mapLineColor,
                                shadowBlur: 10,
                                shadowColor: mapLineColor
                            },
                            tooltip: {
                                show: false
                            },
                            hoverAnimation: false,
                            zlevel: 2
                        }
                    ]
                };
            },
            changeMapChart(selectData, chart) {

                // 11个城市点击后切换图表
                chart.on('click', (params) => {

                    if (!params.data) {
                        return;
                    }

                    const name = params.data.name;

                    selectData.forEach((item) => {

                        if (name !== item.name) {
                            return;
                        }

                        const hasIdx = this.countryData.indexOf(name);

                        if (hasIdx >= 0) {
                            this.countryData.splice(hasIdx, 1);

                        } else {

                            if (this.countryData.length >= 2) {
                                this.countryData.splice(0, 1);
                            }

                            this.countryData.push(name);
                        }

                        this.country = this.countryData.join(',');
                        this.initMapChart();
                    });
                });
            },
            convertData(selectData) {
                let res = [];

                selectData.forEach((item) => {
                    let value = [];

                    value.push(item.lon);
                    value.push(item.lat);

                    res.push({
                        name: item.name,
                        value: value
                    });
                });

                return res;
            },
            creatRadarOption(data) {
                let indicatorData = this.getchartData(data),
                    option = {},
                    seriesData = [],
                    lengendData = [];

                data.list.forEach((item, index) => {

                    seriesData.push({
                        type: 'radar',
                        name: data.title[index],
                        data: [item],
                        symbolSize: 8,
                        lineStyle: {
                            color: lineChartColor2[index]
                        },
                        areaStyle: {
                            color: lineChartColor2[index],
                            opacity: 0.5
                        },
                        itemStyle: {
                            color: lineChartColor2[index],
                            borderWidth: 2
                        }
                    });

                    lengendData.push({
                        name: data.title[index],
                        icon: 'rect',
                        textStyle: {
                            color: labelColor,
                            margin: 7
                        }
                    })
                });

                option = {
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 15,
                        itemHeight: 15,
                        itemGap: 20,
                        bottom: 0,
                        data: lengendData
                    },
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    radar: {
                        radius: '50%',
                        splitNumber: 2,
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        splitArea: false,
                        splitLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        name: {
                            formatter: function (value) {
                                if (value.length > 4) {
                                    value = value.slice(0, 3) + '\n' + value.slice(3);
                                }
                                return value;
                            },
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        indicator: indicatorData
                    },
                    series: seriesData
                };

                return option;
            },
            getchartData(data) {
                let indicatorData = [];

                let numData = data.list.map((item) => {
                    return Math.max.apply(null, item);
                })

                data.column.forEach((item) => {
                    let max = Math.max.apply(null, numData),
                        obj = {
                            name: item,
                            max: max
                        };

                    indicatorData.push(obj);
                });

                return indicatorData;
            },
            creatLineOption(data, type){
                let option,
                    seriesData = [];

                data.list.forEach((item, index) => {

                    seriesData.push({
                        name: data.title[index],
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
                        itemStyle: {
                            normal: {
                                color: pieColor[index].line,
                                lineStyle: {
                                    color: pieColor[index].line
                                }
                            },
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: pieColor[index].line
                                }, {
                                    offset: 1,
                                    color: pieColor[index].area
                                }])
                            }
                        },
                        data: item
                    });

                });

                option = {
                    grid: GRID,
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            show: true,
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        data: data.column
                    },
                    yAxis: {
                        type: 'value',
                        scale: false,
                        nameTextStyle: {
                            color: '#8CC1FF'
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            formatter: type ? '{value}' : '{value} %',
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: lineColor,
                                type: 'dotted'
                            }
                        }
                    },
                    series: seriesData
                };

                return option;

            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "~@/assets/scss/mixins/_mixins.scss";

    $borderColor: #17215F;
    $borderDrakColor: #080B26;

    .inner {
        padding: .2rem 2.08% 0;

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .chart {
            width: 100%;
            height: calc(100% - 34px);
        }

        .top {
            width: 100%;
            height: 64%;
            padding-bottom: .4rem;
            background: url('~@/assets/images/xsdt/mapbg.png') no-repeat center .05rem / 53% 93.1%;

            .part {
                width: 24.57%;
                height: 100%;
                float: left;
                padding: 4.348% 0 5.1%;

                .title {
                    width: 100%;
                    height: .4rem;
                    font-size: .18rem;
                    font-weight: bold;
                    color: #B5C8FF;
                    text-align: center;
                    line-height: .4rem;
                    margin: 0 auto;
                    background: url('~@/assets/images/xsdt/titlebg.png') no-repeat center center / 120% 120%;
                }

                .chart {
                    padding: 0 .5rem;
                }

            }

            .map {
                width: 50.86%;
                padding: 0 4%;

                .title {
                    width: 1.82rem;
                    height: .41rem;
                    font-size: .18rem;
                    font-weight: bold;
                    color: #B5C8FF;
                    text-align: center;
                    line-height: .41rem;
                    margin: 0 auto;
                    background: url('~@/assets/images/xsdt/fwlbg.png') no-repeat center center / 100% 100%;
                }

                .chart {
                    padding: 0;
                }
            }

            .left {
                background: url('~@/assets/images/xsdt/leftbg.png') no-repeat center center / 100% 100%;
            }

            .right {
                background: url('~@/assets/images/xsdt/rightbg.png') no-repeat center center / 100% 100%;
            }
        }

        .bottom {
            width: 100%;
            height: 36%;
            padding: {
                bottom: .4rem;
                left: .4rem;
            }

            .part {
                width: 25%;
                padding-right: .3rem;
                height: 100%;
                float: left;
            }
        }
    }

</style>